import React, { useEffect, useRef } from 'react'
import './Home.css'
import profilePic from './img/p1.png'
import { FaFacebook, FaGithub, FaHackerrank, FaLinkedin, FaWhatsapp } from 'react-icons/fa'
import Typed from 'typed.js'

export default function Home() {

    const typedElement = useRef(null)

    useEffect(() => {
        const options = {
            strings: ['Full Stack Mobile Developer', 'Project Manager', 'Full Stack Web Developer'],
            typeSpeed: 70,
            backSpeed: 70,
            loop: true,
        };

        const typed = new Typed(typedElement.current, options);

        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <div>
            <section className="home" id="home">

                <div className="home-content">
                    <h3>Hi, myself</h3>
                    <h1>Shashindu Chamika</h1>
                    <h3>And I'm a <span className="multiple-text" ref={typedElement}></span></h3>
                    <p>I am an enthusiastic undergraduate with a strong foundation of web and mobile application development techniques. My passion for the IT industry drives me to continuously learn and adapt to new technologies and methods </p>
                    <div className="social-media">
                        <a href="#about"><FaWhatsapp></FaWhatsapp></a>
                        <a href="https://www.linkedin.com/in/shashindu-chamika-a5517330a/"><FaLinkedin></FaLinkedin></a>
                        <a href="https://github.com/WShashinduChamika"><FaGithub></FaGithub></a>
                        <a href="https://web.facebook.com/shashindu.chamika/"><FaFacebook></FaFacebook></a>
                        <a href='https://www.hackerrank.com/profile/shashinduchamik2'><FaHackerrank></FaHackerrank></a>
                    </div>
                    <a href="#about" className="btn">Download CV</a>
                </div>

                <div className="home-img">
                    <img src={profilePic} alt='profile-pic' />
                </div>
            </section>
        </div>
    )
}
